import { render, staticRenderFns } from "./MyTeamStatisticsCards.vue?vue&type=template&id=ef1a57b8"
import script from "./MyTeamStatisticsCards.vue?vue&type=script&lang=js"
export * from "./MyTeamStatisticsCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports